import { gql } from "utils/urql";
import { ArticleTimestampFragment } from "types/api";
import { formatArticleDate, shouldRenderIssueName } from "utils/date";
import styles from "./ArticleTimestamp.module.scss";

const ArticleTimestamp = ({
  datePublished,
  ...props
}: ArticleTimestampFragment) => {
  return (
    <>
      <time className={styles.root} dateTime={datePublished || undefined}>
        {props.__typename === "MagazineArticle" &&
        shouldRenderIssueName(datePublished) ? (
          <a
            className={styles.link}
            href={props.issue.url}
            data-action="click link - magazine issue"
            data-label={props.issue.url}
          >
            {props.issue.issueName} Issue
          </a>
        ) : (
          formatArticleDate(datePublished)
        )}
      </time>
    </>
  );
};

export default ArticleTimestamp;

ArticleTimestamp.fragment = gql`
  fragment articleTimestamp on Article {
    datePublished

    ... on MagazineArticle {
      issue {
        url
        issueName
      }
    }
  }
`;
